:host {
  display: block;
  width: 100%;
  height: inherit;
  background: linear-gradient(
    to right,
    #eee 8%,
    #ddd 18%,
    #eee 33%
  );
  background-size: 936px 104px;
  animation-duration: 1s;
  animation-fill-mode: forwards;
  animation-iteration-count: infinite;
  animation-name: shimmer;
  animation-timing-function: linear;
  user-select: none;
  pointer-events: none;
  border-radius: inherit;
}

:host(.media) {
  height: 100%;
}

/* stylelint-disable property-disallowed-list */
@keyframes shimmer {
  0% {
    background-position: -468px 0;
  }

  100% {
    background-position: 468px 0;
  }
}
